import React from 'react';
import { Button } from 'reactstrap';

const Confirmation = ({ text, confirm, deleteMarker }) => {
  return (
    <div style={{
      background: 'white',
      width: 'fit-content',
      padding: '35px',
      height: 'auto',
      margin: '25% auto',
      borderRadius: '10px',
      position: 'relative'
    }}>
      <h3>Confirm Action!</h3>
      <p>{text}</p>
      <br />
      <div style={{ display: 'flex', justifyContent: 'space-around'}}>
        <Button color="danger" size='sm' onClick={confirm}>Yes</Button>
        <Button color="primary" outline size='sm' onClick={deleteMarker}>No</Button>
      </div>
    </div>
  );
};

export default Confirmation;